import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { useQuery } from '@apollo/client';

import Content from './ContentBox';
import ClickOutside from 'app/src/elements/ClickListener';
import { SELLERS } from './queries';

import {
  MarketOption,
  MarketOptionsContainer,
  OptionText
} from './selectElements';

const SellerSelect = ({ selectedSeller, setSeller, setAsset }) => {
  const [showOptions, setShowOptions] = useState(false);

  const { data } = useQuery(SELLERS)

  if (!data) { return null; }

  const handleSelect = seller => {
    setSeller(seller);
    if (setAsset) { setAsset(null); }
    setShowOptions(false);
  };

  return (
    <View style={{ flex: 1 }}>
      <Pressable onPress={() => setShowOptions(true)}>
        <Content.ValueBox highlight={!!selectedSeller}>
          <Content.Value color={selectedSeller ? 'white' : null}>
            {selectedSeller?.name || 'Choose a Seller'}
          </Content.Value>
        </Content.ValueBox>
      </Pressable>

      {showOptions && (
        <ClickOutside onClick={() => setShowOptions(false)}>
          <MarketOptionsContainer>
            {data.sellers.map(seller => {
              const selected = seller.id === selectedSeller?.id;

              return (
                <MarketOption
                  key={seller.name}
                  onPress={() => handleSelect(seller)}
                  selected={selected}
                >
                  <OptionText selected={selected}>{seller.name}</OptionText>
                </MarketOption>
              );
            })}
          </MarketOptionsContainer>
        </ClickOutside>
      )}
    </View>
  );
};

export default SellerSelect;
